import Bar from "./styled-components/Bar";
import BarColorIndicator from "./styled-components/BarColorIndicator";
import BarHeader from "./styled-components/BarHeader";
import Container from "./styled-components/Container";
import Label from "./styled-components/Label";
import Legend from "./styled-components/Legend";
import LegendGroup from "./styled-components/LegendGroup";
import StackBase from "./styled-components/StackBase";
import Title from "./styled-components/Title";

interface StackedBarProps {
  title: string;
  userColor: string;
  averageColor: string;
  userValue: number;
  averageValue: number;
  total: number;
}

function DataBar({
  title,
  userColor,
  averageColor,
  userValue,
  averageValue,
  total,
}: StackedBarProps) {
  const userPercentage = (userValue / total) * 100;
  const averagePercentage = (averageValue / total) * 100;

  // const areValuesClose = Math.abs(userPercentage - averagePercentage) < 5;
  const areValuesClose = false;
  const isUserValueGreater = userValue > averageValue;

  const userZIndex = areValuesClose ? 0 : isUserValueGreater ? undefined : 1;
  const averageZIndex = areValuesClose ? 0 : isUserValueGreater ? 1 : 0;

  return (
    <Container>
      <BarHeader>
        <Title>{title}</Title>
        <LegendGroup>
          <Legend>
            <BarColorIndicator color={averageColor} />
            <Label>media</Label>
          </Legend>
          <Legend>
            <BarColorIndicator color={userColor} />
            <Label>tu huella</Label>
          </Legend>
        </LegendGroup>
      </BarHeader>
      <StackBase>
        <Bar
          percentage={averagePercentage}
          color={averageColor}
          zIndex={averageZIndex}
        />
        <Bar percentage={userPercentage} color={userColor} zIndex={userZIndex}>
          <span>{userValue.toFixed(2)}</span>
        </Bar>
      </StackBase>
    </Container>
  );
}

export default DataBar;
